import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { RevokeContactConsentRequest } from './types/ContactConsent';

export function requestRevokeContactConsent(
    data: RevokeContactConsentRequest,
    signal?: AbortSignal,
): AxiosPromise<unknown> {
    return libApiInstance.post(`/contacts/${data.contactId}/consent/revoke`, data, {
        signal,
    });
}
